/**
 * Profile — the signed-in person, not the Company: the email this
 * workspace is open under, and the way out.
 *
 * It is a section because on a phone there is no sidebar and so no
 * account menu at its foot: the tab bar's Settings is the only way to the
 * account, as a phone app keeps it (DESIGN-SYSTEM.md, Admin global
 * navigation). The password and the authenticator are intake's sign-in,
 * not this app's, so nothing here edits them.
 */
import { Button } from "../../components/ui/Button";
import { useOptionalAuth } from "../../lib/auth";
import { SectionHeader } from "./section-chrome";
import chrome from "./settings.module.css";

export function ProfileSection() {
  const auth = useOptionalAuth();
  const logOut = () => {
    void (async () => {
      await auth?.signOut();
      window.location.assign("/login");
    })();
  };
  return (
    <section className={chrome.section}>
      <SectionHeader
        title="Profile"
        description="The sign-in this workspace is open under."
      />
      <ul className={chrome.listBordered}>
        <li className={chrome.row}>
          <div className={chrome.rowText}>
            <p className={chrome.rowName}>Email</p>
            <p className={chrome.rowMeta}>{auth?.user?.email ?? "—"}</p>
          </div>
          <Button size="sm" variant="secondary" onClick={logOut}>
            Log out
          </Button>
        </li>
      </ul>
    </section>
  );
}
